import { render } from "./EditBudget.vue?vue&type=template&id=bd5362e2"
import script from "./EditBudget.vue?vue&type=script&lang=js"
export * from "./EditBudget.vue?vue&type=script&lang=js"

import "./EditBudget.vue?vue&type=style&index=0&id=bd5362e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__